import { useEffect, useState } from 'react';
import { api } from '../../api/client';
import { useAuth } from '../../stores/AuthContext';
import styles from './DashboardHome.module.css';

interface SchoolData {
  name: string;
  plan: string;
  stats: {
    totalStudents: number;
    totalStaff: number;
    totalGroups: number;
    totalPayments: number;
  };
}

export default function DashboardHome() {
  const { user } = useAuth();
  const [school, setSchool] = useState<SchoolData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get<SchoolData>('/api/school')
      .then((data) => setSchool(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className={styles.container}>
        <p>Cargando...</p>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <h1>Dashboard Principal</h1>
      <p className={styles.subtitle}>
        Bienvenido, {user?.name || 'Administrador'}. — {school?.name || 'Escuela'} (
        {school?.plan === 'pro' ? 'Profesional' : 'Básico'})
      </p>

      <div className={styles.statsGrid}>
        <div className={styles.statCard}>
          <h3>Alumnos</h3>
          <p className={styles.statValue}>{school?.stats?.totalStudents ?? 0}</p>
        </div>
        <div className={styles.statCard}>
          <h3>Personal</h3>
          <p className={styles.statValue}>{school?.stats?.totalStaff ?? 0}</p>
        </div>
        <div className={styles.statCard}>
          <h3>Grupos</h3>
          <p className={styles.statValue}>{school?.stats?.totalGroups ?? 0}</p>
        </div>
        <div className={styles.statCard}>
          <h3>Pagos</h3>
          <p className={styles.statValue}>{school?.stats?.totalPayments ?? 0}</p>
        </div>
      </div>
    </div>
  );
}
